import {gql} from '@apollo/client'

export const STORAGE = gql`
  query Storage {
    storage {
      used
      limit
      locked
      importEnabled
    }
  }
`
